import { ConversationView, TabKey } from "./types";

export const filterByTab = (
  conversations: ConversationView[],
  tab: TabKey,
): ConversationView[] => {
  switch (tab) {
    case "starred":
      return conversations.filter((c) => c.starred && !c.archived);
    case "unread":
      return conversations.filter((c) => c.unreadCount > 0 && !c.archived);
    case "archived":
      return conversations.filter((c) => c.archived);
    case "all":
    default:
      return conversations.filter((c) => !c.archived);
  }
};

// Newest activity first; conversations without messages sort last.
export const sortByActivity = (
  conversations: ConversationView[],
): ConversationView[] =>
  [...conversations].sort((a, b) => {
    const ta = a.lastMessageAt ? new Date(a.lastMessageAt).getTime() : 0;
    const tb = b.lastMessageAt ? new Date(b.lastMessageAt).getTime() : 0;
    return tb - ta;
  });
